<template>
  <div>
    <b-table ref="foliotable" selectable select-mode="single" sort-by="expiryDate" sticky-header="80vh"
      @row-selected="onRowSelected" sort-icon-left :items="paginatedCells()" :fields="visible_cells_fields" :tbody-tr-class="getRowClass">
      <template #cell(expiryDate)="row">
        {{ row.item.expiryDate }}
      </template>
  
      <template #cell(name)="row">
        <span class="small-black-card">{{ row.item.name }}</span>
      </template>
  
      <template #cell(band)="row">
        <span class="small-black-card">{{ row.item.band }}</span>
      </template>
    </b-table>
    
    <!-- Пагинация -->
    <b-pagination
      v-model="currentPage"
      :total-rows="visibleCellsRows().length"
      :per-page="perPage"
      align="center"
      size="sm"
      class="mt-3"
    />
  </div>
</template>

<script>
import * as utils from '@/utils/utils'
import { mapStores } from 'pinia'
import { useRoutesStore } from '@/stores/routes'
import { useMomentaryStore } from '@/stores/momentary'
import { useDeviceStore } from '@/stores/device'
import { useUserStore } from '@/stores/user'
import { useCartStore } from '@/stores/cart'
import { useCatalogsStore } from '@/stores/catalogs'
import dayjs from 'dayjs'

export default {
  name: 'FolioTable',
  // props: ['map'],
  data() {
    return {
      // sortBy: 'bandid',
      filterSelectAll: false,
      preparingCells: false,
      orderPlaced: false,
      // viewParent: this.$parent.$parent.$parent.$parent, // Удалено - используем динамический поиск
      selectedType_UKHO: 'AVCS',
      selectedType_Primar: 'ENC',
      selectedPeriod: '4',
      priceCalculating: false,
      openCellsList: false,
      cellList: '',
      // Пагинация
      currentPage: 1,
      perPage: 20,
    }
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    ...mapStores(useRoutesStore, useMomentaryStore, useUserStore, useDeviceStore, useCartStore, useCatalogsStore),
    visible_cells_fields() {
      return [
        { key: 'name', label: this.$t('order.name'), sortable: true, tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'band', label: 'Band', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'expiryDate', label: this.$t('order.validTill'), sortable: true, tdClass: 'small-black', thClass: 'small-gray' },
      ]
    },
    visible_publications_fields() {
      return [
        { key: 'name', label: this.$t('order.name'), sortable: true, tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'expiryDate', label: this.$t('order.till'), sortable: true, tdClass: 'small-black', thClass: 'small-gray' },
      ]
    },

  },
  methods: {

    // Правильный способ получить доступ к методу из корневого компонента index.vue
    getRootMethod() {
      // Способ 1: Динамический поиск в цепочке родителей
      let parent = this.$parent;
      while (parent) {
        if (parent.aaaa && typeof parent.aaaa === 'function') {
          return parent.aaaa();
        }
        parent = parent.$parent;
      }
      return 'Method aaaa() not found';
    },

    // Альтернативный способ - через события (более надежно)
    callParentMethod() {
      this.$emit('call-parent-method');
    },

    isValid(date) {
      // const inputDate = new Date(date);
      // const currentDate = new Date();
      // const threeDaysAgo = new Date(currentDate.setDate(currentDate.getDate() - 30));
      // console.log("aaa", inputDate, currentDate, threeDaysAgo)

      //TODO

      let d1 = dayjs(date)
      let d2 = dayjs()
      let dd = d2.diff(d1, 'day')

      console.log('dddd', date, dd)

      return dd < 30
    },

    bandName(id) {
      let bandCode = id && id.length >= 3 ? Number(id[2]) : -1
      return utils.getBandName(bandCode)
    },

    // Функция для определения класса строки
    getRowClass(item) {
      if (!item.expiryDate) {
        return 'purchased-row'; // По умолчанию зеленый если нет даты
      }

      const expiryDate = dayjs(item.expiryDate);
      const currentDate = dayjs();

      if (expiryDate.isAfter(currentDate)) {
        return 'purchased-row'; // Зеленый фон - дата в будущем
      } else {
        return 'expired-row'; // Красный фон - дата прошла
      }
    },

    onRowSelected(items) {
      if (items.length > 0) {
        const selectedId = items[0].name
        // Найдем родительский компонент index.vue и вызовем его метод
        let parent = this.$parent;
        while (parent) {
          if (parent.showFolioCell && typeof parent.showFolioCell === 'function') {
            parent.showFolioCell(selectedId);
            break;
          }
          parent = parent.$parent;
        }
      }
    },

    sortBands(a, b) {
      return this.cellById(a.id).usageBand - this.cellById(b.id).usageBand
    },

    visibleCellsRows() {
      const cells = this.deviceStore.orderedData.primar.enc;
      console.log('[FolioTable] visibleCellsRows: получили данные:', cells, 'количество:', cells ? cells.length : 0);
      return cells;
    },

    // Возвращает данные для текущей страницы
    paginatedCells() {
      const cells = this.visibleCellsRows();
      if (!cells || cells.length === 0) return [];
      
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return cells.slice(start, end);
    },

    // Возвращает все ячейки отсортированные по Valid Till для PDF
    getSortedCellsForPDF() {
      const cells = this.visibleCellsRows();
      if (!cells) return [];
      
      // Сортируем по expiryDate (Valid Till)
      return [...cells].sort((a, b) => {
        if (!a.expiryDate && !b.expiryDate) return 0;
        if (!a.expiryDate) return 1;
        if (!b.expiryDate) return -1;
        return a.expiryDate.localeCompare(b.expiryDate);
      });
    },
  },
}
</script>

<style scoped>
button:hover {
  color: black;
  background-color: white;
  outline: none !important;
}

/* Слабый зеленый фон для купленных ранее */
.purchased-row {
  background-color: #eafbe7 !important;
}

/* Слабый красный фон для просроченных */
.expired-row {
  background-color: #fbe7e7 !important;
}

/* Стили для выбранных строк */
.purchased-row.table-active {
  background-color: #a8d8a0 !important;
}

.expired-row.table-active {
  background-color: #f2bfbf71 !important;
}

/* Дополнительные стили для перекрытия Bootstrap-Vue */
::v-deep .purchased-row>td {
  background-color: #eafbe7 !important;
}

::v-deep .expired-row>td {
  background-color: #fbe7e7 !important;
}

/* Стили для выбранных строк - ячейки */
::v-deep .purchased-row.table-active>td {
  background-color: #a8d8a0 !important;
}

::v-deep .expired-row.table-active>td {
  background-color: #f0a0a0 !important;
}

::v-deep .table tbody tr.purchased-row {
  background-color: #eafbe7 !important;
}

::v-deep .table tbody tr.expired-row {
  background-color: #fbe7e7 !important;
}

/* Стили для выбранных строк в таблице */
::v-deep .table tbody tr.purchased-row.table-active {
  background-color: #a8d8a0 !important;
}

::v-deep .table tbody tr.expired-row.table-active {
  background-color: #f0a0a0 !important;
}

::v-deep .table tbody tr.purchased-row:hover {
  background-color: #d4f4d0 !important;
}

::v-deep .table tbody tr.expired-row:hover {
  background-color: #f4d0d0 !important;
}

/* Hover для выбранных строк */
::v-deep .table tbody tr.purchased-row.table-active:hover {
  background-color: #95d085 !important;
}

::v-deep .table tbody tr.expired-row.table-active:hover {
  background-color: #ed8585 !important;
}
</style>
